import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  // Magnum Dashboard
  private ENDPOINT_FAULT_PIE_CHART = "/dashboard/pie-chart";
  private ENDPOINT_FAULT_BAR_CHART = "/dashboard/assets-data";
  private ENDPOINT_DAILY_PROGRESS = "/dashboard/daily-progress";
  private ENDPOINT_OVER_DUE = "/dashboard/overdue-fault-calls";
  private ENDPOINT_PREVENTIVE_MAINTENANCE =
    "/dashboard/preventative-maintenance";
  private ENDPOINT_FAULT_TYPES = "/faults";
  private ENDPOINT_FAULT_HIERARCHY = "/dashboard/hierarchy";
  private ENDPOINT_MAINTENANCE_COUNT = "/v5/job-orders/maintenances/count";
  private ENDPOINT_MAINTENANCES = "/v5/job-orders/maintenances";
  private ENDPOINT_MAINTENANCE_CALENDAR = "/v5/job-orders/maintenances/calendar";
  private ENDPOINT_MAINTENANCE_RECENT_ACTIVITY = "/v5/job-orders/maintenances/recent-activity";
  private ENDPOINT_COMPLIANCE_METRICS = "/asset-compliance/dashboard/metrics";
  private ENDPOINT_COMPLIANCE_CALENDAR = "/asset-compliance/dashboard/calendar";
  private ENDPOINT_COMPLIANCE_RECENT_ACTIVITY = "/asset-compliance/dashboard/recent-activity";
  private ENDPOINT_COMPLIANCE_RECORDS = "/asset-compliance/dashboard/records";
  private ENDPOINT_ASSET_RECENT_ACTIVITY = "/asset-dashboard/recent-activity";
  private ENDPOINT_ASSET_STATUS_COUNTS = "/asset-dashboard/status-counts";
  private ENDPOINT_ASSET_OPEN_JOB_ORDERS = "/asset-dashboard/open-job-orders";

  constructor(private http: HttpClient) {}

  ///////////////////////////////////////////////////////  Magnum Dashboard  //////////////////////////////////

  public getMagnumPieChart(
    joType: any,
    group: any,
    roleId: any,
    fromDate: any,
    toDate: any,
    systems: any
  ) {
    // var fromDate = '2020-01-01';
    let params = new HttpParams();
    params = params.set("joTypes", joType);
    params = params.set("group", group);
    params = params.set("fromDate", fromDate);
    params = params.set("toDate", toDate);

    if (systems) {
      params = params.set("systems", systems);
    }

    if (roleId != null) {
      params = params.set("roleId", roleId);
    }

    return this.http
      .get(environment.base_url + this.ENDPOINT_FAULT_PIE_CHART, {
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getMagnumBarHorizontalStacked(
    roleId: any,
    fromDate: any,
    toDate: any
  ) {
    // roleId no need here
    let params = new HttpParams();
    //params = params.set('fromDate', fromDate);
    //params = params.set('toDate', toDate);
    if (roleId != null) {
      params = params.set("roleId", roleId);
    }
    return this.http
      .get(environment.base_url + this.ENDPOINT_FAULT_BAR_CHART, {
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getMagnumProgressBar(roleId: any, fromDate: any, toDate: any) {
    let params = new HttpParams();
    if (roleId != null) {
      params = params.set("roleId", roleId);
    }
    params = params.set("fromDate", fromDate);
    params = params.set("toDate", toDate);
    return this.http
      .get(environment.base_url + this.ENDPOINT_DAILY_PROGRESS, {
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getMagnumOverDue(roleId: any, fromDate: any, toDate: any) {
    let params = new HttpParams();
    if (roleId != null) {
      params = params.set("roleId", roleId);
    }
    params = params.set("fromDate", fromDate);
    params = params.set("toDate", toDate);
    return this.http
      .get(environment.base_url + this.ENDPOINT_OVER_DUE, { params: params })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getMagnumPreventiveMaintenance(
    roleId: any,
    fromDate: any,
    toDate: any
  ) {
    // var fromDate = '2020-01-01';
    let params = new HttpParams();
    params = params.set("fromDate", fromDate);
    params = params.set("toDate", toDate);
    if (roleId != null) {
      params = params.set("roleId", roleId);
    }

    return this.http
      .get(environment.base_url + this.ENDPOINT_PREVENTIVE_MAINTENANCE, {
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getMagnumFaultTypes() {
    return this.http.get(environment.base_url + this.ENDPOINT_FAULT_TYPES).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  public getMagnumCompanies() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_FAULT_HIERARCHY)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getMaintenanceCount(filter: {
    dateFilter: string;
    startDateTime?: string | null;
    endDateTime?: string | null;
    assetTypeIds?: string | number | null;
    userGroupIds?: string | number | null;
    jobOrderServiceZoneIds?: string | number | null;
    assetServiceZoneIds?: string | number | null;
  }) {
    let params = new HttpParams();
    params = params.set("dateFilter", filter.dateFilter);

    if (filter.dateFilter === 'CUSTOM') {
      if (filter.startDateTime) {
        params = params.set("startDateTime", filter.startDateTime);
      }
      if (filter.endDateTime) {
        params = params.set("endDateTime", filter.endDateTime);
      }
    }
    if (filter.assetTypeIds != null && filter.assetTypeIds !== "") {
      params = params.set("assetTypeIds", String(filter.assetTypeIds));
    }
    if (filter.userGroupIds != null && filter.userGroupIds !== "") {
      params = params.set("userGroupIds", String(filter.userGroupIds));
    }
    if (filter.jobOrderServiceZoneIds != null && filter.jobOrderServiceZoneIds !== "") {
      params = params.set("jobOrderServiceZoneIds", String(filter.jobOrderServiceZoneIds));
    }
    if (filter.assetServiceZoneIds != null && filter.assetServiceZoneIds !== "") {
      params = params.set("assetServiceZoneIds", String(filter.assetServiceZoneIds));
    }

    return this.http
      .get(environment.base_url + this.ENDPOINT_MAINTENANCE_COUNT, {
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getMaintenances(filter: {
    dateFilter: string;
    startDateTime?: string | null;
    endDateTime?: string | null;
    assetTypeIds?: string | number | null;
    userGroupIds?: string | number | null;
    jobOrderServiceZoneIds?: string | number | null;
    assetServiceZoneIds?: string | number | null;
    columnName?: string;
    sortOrder?: string;
    perPage?: number;
    startFrom?: number;
    search?: string | null;
  }) {
    let params = new HttpParams();
    params = params.set("dateFilter", filter.dateFilter);
    params = params.set("columnName", filter.columnName || "installationTime");
    params = params.set("sortOrder", filter.sortOrder || "asc");
    params = params.set("perPage", String(filter.perPage ?? 5));
    params = params.set(
      "maintenanceStatus", "PENDING,OVERDUE"
    );

    if (filter.startFrom != null) {
      params = params.set("startFrom", String(filter.startFrom));
    }
    if (filter.search != null && filter.search !== "") {
      params = params.set("search", String(filter.search));
    }
    if (filter.dateFilter === 'CUSTOM') {
      if (filter.startDateTime) {
        params = params.set("startDateTime", filter.startDateTime);
      }
      if (filter.endDateTime) {
        params = params.set("endDateTime", filter.endDateTime);
      }
    }
    if (filter.assetTypeIds != null && filter.assetTypeIds !== "") {
      params = params.set("assetTypeIds", String(filter.assetTypeIds));
    }
    if (filter.userGroupIds != null && filter.userGroupIds !== "") {
      params = params.set("userGroupIds", String(filter.userGroupIds));
    }
    if (filter.jobOrderServiceZoneIds != null && filter.jobOrderServiceZoneIds !== "") {
      params = params.set("jobOrderServiceZoneIds", String(filter.jobOrderServiceZoneIds));
    }
    if (filter.assetServiceZoneIds != null && filter.assetServiceZoneIds !== "") {
      params = params.set("assetServiceZoneIds", String(filter.assetServiceZoneIds));
    }

    return this.http
      .get(environment.base_url + this.ENDPOINT_MAINTENANCES, {
        observe: "response",
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getMaintenanceCalendar(filter: {
    dateFilter: string;
    startDateTime?: string | null;
    endDateTime?: string | null;
    assetTypeIds?: string | number | null;
    userGroupIds?: string | number | null;
    jobOrderServiceZoneIds?: string | number | null;
    assetServiceZoneIds?: string | number | null;
  }) {
    let params = new HttpParams();
    params = params.set("dateFilter", filter.dateFilter);

    if (filter.dateFilter === 'CUSTOM') {
      if (filter.startDateTime) {
        params = params.set("startDateTime", filter.startDateTime);
      }
      if (filter.endDateTime) {
        params = params.set("endDateTime", filter.endDateTime);
      }
    }
    params = params.set(
      "maintenanceStatus", "PENDING,COMPLETED,OVERDUE"
    );
    if (filter.assetTypeIds != null && filter.assetTypeIds !== "") {
      params = params.set("assetTypeIds", String(filter.assetTypeIds));
    }
    if (filter.userGroupIds != null && filter.userGroupIds !== "") {
      params = params.set("userGroupIds", String(filter.userGroupIds));
    }
    if (filter.jobOrderServiceZoneIds != null && filter.jobOrderServiceZoneIds !== "") {
      params = params.set("jobOrderServiceZoneIds", String(filter.jobOrderServiceZoneIds));
    }
    if (filter.assetServiceZoneIds != null && filter.assetServiceZoneIds !== "") {
      params = params.set("assetServiceZoneIds", String(filter.assetServiceZoneIds));
    }

    return this.http
      .get(environment.base_url + this.ENDPOINT_MAINTENANCE_CALENDAR, {
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getMaintenanceRecentActivity(limit = 300) {
    const params = new HttpParams().set("limit", String(limit));

    return this.http
      .get(environment.base_url + this.ENDPOINT_MAINTENANCE_RECENT_ACTIVITY, {
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getComplianceMetrics(filter: {
    dateFilter: string;
    fromDate?: string | null;
    toDate?: string | null;
    assetsTypeId?: string | number | null;
    assetTypeIds?: string | number | null;
    userGroupIds?: string | number | null;
    assetServiceZoneIds?: string | number | null;
    assetId?: string | number | null;
  }) {
    let params = new HttpParams();
   // params = params.set("dateFilter", filter.dateFilter);

    if (filter.dateFilter === 'CUSTOM') {
      if (filter.fromDate) {
        params = params.set("fromDate", filter.fromDate);
      }
      if (filter.toDate) {
        params = params.set("toDate", filter.toDate);
      }
    }
    const assetsTypeId = filter.assetsTypeId ?? filter.assetTypeIds;
    if (assetsTypeId != null && assetsTypeId !== "") {
      params = params.set("assetsTypeId", String(assetsTypeId));
    }
    if (filter.userGroupIds != null && filter.userGroupIds !== "") {
      params = params.set("userGroupId", String(filter.userGroupIds));
    }
    if (filter.assetServiceZoneIds != null && filter.assetServiceZoneIds !== "") {
      params = params.set("serviceZoneId", String(filter.assetServiceZoneIds));
    }
    if (filter.assetId != null && filter.assetId !== "") {
      params = params.set("assetId", String(filter.assetId));
    }

    return this.http
      .get(environment.base_url + this.ENDPOINT_COMPLIANCE_METRICS, {
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getComplianceCalendar(filter: {
    dateFilter: string;
    fromDate?: string | null;
    toDate?: string | null;
    assetsTypeId?: string | number | null;
    assetTypeIds?: string | number | null;
    userGroupIds?: string | number | null;
    assetServiceZoneIds?: string | number | null;
    assetId?: string | number | null;
  }) {
    let params = new HttpParams();
    params = params.set("dateFilter", filter.dateFilter);

    if (filter.dateFilter === 'CUSTOM') {
      if (filter.fromDate) {
        params = params.set("fromDate", filter.fromDate);
      }
      if (filter.toDate) {
        params = params.set("toDate", filter.toDate);
      }
    }
    const assetsTypeId = filter.assetsTypeId ?? filter.assetTypeIds;
    if (assetsTypeId != null && assetsTypeId !== "") {
      params = params.set("assetsTypeId", String(assetsTypeId));
    }
    if (filter.userGroupIds != null && filter.userGroupIds !== "") {
      params = params.set("userGroupId", String(filter.userGroupIds));
    }
    if (filter.assetServiceZoneIds != null && filter.assetServiceZoneIds !== "") {
      params = params.set("serviceZoneId", String(filter.assetServiceZoneIds));
    }
    if (filter.assetId != null && filter.assetId !== "") {
      params = params.set("assetId", String(filter.assetId));
    }

    return this.http
      .get(environment.base_url + this.ENDPOINT_COMPLIANCE_CALENDAR, {
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getComplianceRecentActivity(limit = 100) {
    const params = new HttpParams().set("limit", String(limit));

    return this.http
      .get(environment.base_url + this.ENDPOINT_COMPLIANCE_RECENT_ACTIVITY, {
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getAssetRecentActivity(filter: {
    limit?: number;
    assetsStatusId?: string | number | null;
    assetsTypeId?: string | number | null;
    userGroupId?: string | number | null;
    serviceZoneId?: string | number | null;
  } = {}) {
    let params = new HttpParams().set("limit", String(filter.limit ?? 10));

    if (filter.assetsStatusId != null && filter.assetsStatusId !== "") {
      params = params.set("assetsStatusId", String(filter.assetsStatusId));
    }
    if (filter.assetsTypeId != null && filter.assetsTypeId !== "") {
      params = params.set("assetsTypeId", String(filter.assetsTypeId));
    }
    if (filter.userGroupId != null && filter.userGroupId !== "") {
      params = params.set("userGroupId", String(filter.userGroupId));
    }
    if (filter.serviceZoneId != null && filter.serviceZoneId !== "") {
      params = params.set("serviceZoneId", String(filter.serviceZoneId));
    }

    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSET_RECENT_ACTIVITY, {
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getAssetStatusCounts(filter: {
    assetsStatusId?: string | number | null;
    assetsTypeId?: string | number | null;
    userGroupId?: string | number | null;
    serviceZoneId?: string | number | null;
  } = {}) {
    let params = new HttpParams();

    if (filter.assetsStatusId != null && filter.assetsStatusId !== "") {
      params = params.set("assetsStatusId", String(filter.assetsStatusId));
    }
    if (filter.assetsTypeId != null && filter.assetsTypeId !== "") {
      params = params.set("assetsTypeId", String(filter.assetsTypeId));
    }
    if (filter.userGroupId != null && filter.userGroupId !== "") {
      params = params.set("userGroupId", String(filter.userGroupId));
    }
    if (filter.serviceZoneId != null && filter.serviceZoneId !== "") {
      params = params.set("serviceZoneId", String(filter.serviceZoneId));
    }

    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSET_STATUS_COUNTS, {
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getAssetOpenJobOrders(filter: {
    page?: number;
    perPage?: number;
    columnName?: string;
    sortOrder?: string;
    assetsStatusId?: string | number | null;
    assetsTypeId?: string | number | null;
    userGroupId?: string | number | null;
    serviceZoneId?: string | number | null;
    search?: string | null;
  } = {}) {
    let params = new HttpParams();
    params = params.set("page", String(filter.page ?? 1));
    params = params.set("perPage", String(filter.perPage ?? 10));
    params = params.set("columnName", filter.columnName || "jobOrderNumber");
    params = params.set("sortOrder", filter.sortOrder || "desc");

    if (filter.assetsStatusId != null && filter.assetsStatusId !== "") {
      params = params.set("assetsStatusId", String(filter.assetsStatusId));
    }
    if (filter.assetsTypeId != null && filter.assetsTypeId !== "") {
      params = params.set("assetsTypeId", String(filter.assetsTypeId));
    }
    if (filter.userGroupId != null && filter.userGroupId !== "") {
      params = params.set("userGroupId", String(filter.userGroupId));
    }
    if (filter.serviceZoneId != null && filter.serviceZoneId !== "") {
      params = params.set("serviceZoneId", String(filter.serviceZoneId));
    }
    if (filter.search != null && filter.search !== "") {
      params = params.set("search", String(filter.search));
    }

    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSET_OPEN_JOB_ORDERS, {
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getComplianceRecords(filter: {
    recordType: 'CERTIFICATION' | 'INSPECTION';
    page?: number;
    perPage?: number;
    columnName?: string;
    sortOrder?: string;
    dateFilter: string;
    fromDate?: string | null;
    toDate?: string | null;
    assetsTypeId?: string | number | null;
    assetTypeIds?: string | number | null;
    userGroupIds?: string | number | null;
    assetServiceZoneIds?: string | number | null;
    assetId?: string | number | null;
    search?: string | null;
  }) {
    let params = new HttpParams();
    params = params.set("recordType", filter.recordType);
    params = params.set("page", String(filter.page ?? 1));
    params = params.set("perPage", String(filter.perPage ?? 10));
    params = params.set("columnName", filter.columnName || "dueDate");
    params = params.set("sortOrder", filter.sortOrder || "desc");
    params = params.set("dateFilter", filter.dateFilter);

    params = params.set(
      "statuses", "PENDING,OVERDUE"
    );

    if (filter.dateFilter === 'CUSTOM') {
      if (filter.fromDate) {
        params = params.set("fromDate", filter.fromDate);
      }
      if (filter.toDate) {
        params = params.set("toDate", filter.toDate);
      }
    }
    const assetsTypeId = filter.assetsTypeId ?? filter.assetTypeIds;
    if (assetsTypeId != null && assetsTypeId !== "") {
      params = params.set("assetsTypeId", String(assetsTypeId));
    }
    if (filter.userGroupIds != null && filter.userGroupIds !== "") {
      params = params.set("userGroupId", String(filter.userGroupIds));
    }
    if (filter.assetServiceZoneIds != null && filter.assetServiceZoneIds !== "") {
      params = params.set("serviceZoneId", String(filter.assetServiceZoneIds));
    }
    if (filter.assetId != null && filter.assetId !== "") {
      params = params.set("assetId", String(filter.assetId));
    }
    if (filter.search != null && filter.search !== "") {
      params = params.set("search", String(filter.search));
    }

    return this.http
      .get(environment.base_url + this.ENDPOINT_COMPLIANCE_RECORDS, {
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }
}
